import { useNode } from '@craftjs/core';
import {
  FormControlLabel,
  FormGroup,
  Stack,
  Switch,
  TextField,
} from '@mui/material';

export interface MetaDataProps {
  title?: string;
  subtitle?: string;
  showMetaData?: boolean;
}

const ClassSettings = () => {
  const {
    props,
    actions: { setProp },
  } = useNode((node) => ({
    props: node.data.props,
  }));

  return (
    <Stack spacing={2}>
      <TextField
        label="Título"
        size="small"
        value={props?.title}
        onChange={(e) => {
          setProp((props: MetaDataProps) => {
            props.title = e.target.value;
            return props;
          });
        }}
      />
      <TextField
        label="Subtitulo"
        size="small"
        value={props?.subtitle}
        onChange={(e) => {
          setProp((props: MetaDataProps) => {
            props.subtitle = e.target.value;
            return props;
          });
        }}
      />
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={props.backgroundFixed}
              onChange={(e: any) => {
                setProp((props: MetaDataProps) => {
                  props.showMetaData = e.target.checked;
                  return props;
                });
              }}
            />
          }
          label="Mostrar título"
        />
      </FormGroup>
    </Stack>
  );
};

export default ClassSettings;
